import React from "react";

const SimpleSelect = ({
  title,
  selectoptions,
  value,
  onChange,
  required,
  disabled 
}) => {
  return (
    <div>
      <label
        htmlFor={title}
        className="block text-sm font-medium leading-6 text-gray-500"
      >
        {title} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className="w-full border border-gray-300 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
      >
        <option value="">Select</option>
        {selectoptions.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SimpleSelect;
